import React, { useEffect, useState } from 'react';
import ImageComponent from '../Components/ImageComponent';
import successfullimg from '../../assets/images/successfullimg.png';
import errorimg from '../../assets/images/ErrorIcon.svg';

const AuthCallback = () => {
  const [platform, setPlatform] = useState('the platform');
  const [status, setStatus] = useState('loading'); // 'success', 'error', 'loading'
  const [message, setMessage] = useState('Processing authentication...');

  useEffect(() => {
    const safeClose = (redirectUrl = '/') => {
      if (window.opener && !window.opener.closed) {
        window.close(); // Close popup
      } else {
        window.location.href = redirectUrl || '/'; // Redirect for same-tab flow
      }
    };

    const processCallback = () => {
      let searchParams = new URLSearchParams(window.location.search);
      let hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))
      let error = hashParams.get('error') || searchParams.get('error');
      let code =  searchParams.get('code') || hashParams.get('code');
      let state = hashParams.get('state') || searchParams.get('state');
      let accessToken =
        hashParams.get('access_token') || searchParams.get('access_token');

      let platformName = 'the platform';
      let returnUrl = '/';

      // Decode state
      if (state) {
        try {
          const stateObj = JSON.parse(decodeURIComponent(atob(state)));
          platformName = stateObj.platform || 'Google';
          returnUrl = stateObj.returnUrl || '/';
          setPlatform(platformName);
        } catch (e) {
          // Fallback: parse plain JSON (WhatsApp case)
          const stateObj = JSON.parse(decodeURIComponent(state));
          platformName = stateObj.platform || 'Google';
          returnUrl = stateObj.returnUrl || '/';
          setPlatform(platformName);

          console.warn('Failed to decode state');
        }
      }

      //  Handle Meta/WhatsApp first cancel redirect
      if (window.location.href.includes('/cancel') && !sessionStorage.getItem('fb_retry')) {
        sessionStorage.setItem('fb_retry', '1');
        console.warn('Meta cancel redirect detected, skipping this round...');
        setStatus('loading');
        setMessage('Waiting for authentication...');
        return; // Let next redirect finish
      }


      // Error case
      if (error) {
        setStatus('error');
        setMessage('Authentication was cancelled or failed. Please try again.');
        sessionStorage.removeItem('fb_retry');
        return setTimeout(() => safeClose(returnUrl), 2000);
      }

      // Access token (Facebook implicit flow)
      if (accessToken) {
        const handleImplicitResponse = async () => {
          try {
            if (platformName === 'meta') {
              // Fetch Facebook user info
              const response = await fetch(
                `https://graph.facebook.com/me?fields=id,name,email&access_token=${accessToken}`
              );
              const data = await response.json();

              if (window.opener) {
                window.opener.postMessage(
                  {
                    accessToken,
                    name: data.name,
                    email: data.email,
                    userID: data.id,
                    returnUrl,
                    platform: platformName,
                  },
                  new URL(returnUrl).origin
                );
              }
              setMessage(
                `Welcome ${data.name || 'User'}! You're all set with Facebook.`
              );
            } else {
              // Other implicit token-based providers
              if (window.opener) {
                window.opener.postMessage(
                  {
                    code: accessToken,
                    returnUrl,
                    platform: platformName,
                  },
                  new URL(returnUrl).origin
                );
              }
              setMessage(`You're all set with ${platformName} Authentication.`);
            }
            setStatus('success');
          } catch (err) {
            console.error('Failed to process implicit auth:', err);
            setStatus('error');
            setMessage('Failed to complete authentication.');
          } finally {
            sessionStorage.removeItem('fb_retry'); // ✅ clear on success
            setTimeout(() => safeClose(returnUrl), 2000);
          }
        };

        handleImplicitResponse();
        return;
      }

      // Authorization code (e.g., Google, Microsoft)
      if (code) {
        try {
          if (window.opener) {
            window.opener.postMessage(
              { code, returnUrl, platform: platformName },
              new URL(returnUrl).origin
            );
            setStatus('success');
            setMessage(`Thanks for logging in with ${platformName}.`);
          } else {
            setStatus('error');
            setMessage(
              'Authentication succeeded, but could not contact parent window.'
            );
          }
        } catch (error) {
          console.error('Error processing auth callback:', error);
          setStatus('error');
          setMessage('An error occurred during authentication.');
        } finally {
          sessionStorage.removeItem('fb_retry'); 
          setTimeout(() => safeClose(returnUrl), 2000);
        }
        return;
      }

      // Nothing found
      setStatus('error');
      setMessage('No authentication data received.');
      sessionStorage.removeItem('fb_retry');
      setTimeout(() => safeClose(returnUrl), 2000);
    };

    processCallback();
  }, []);

  return (
    <div className='card border p-0 overflow-hidden align-items-center justify-content-center h-100vh d-flex'>
      <div className='card-body p-12 d-flex align-items-center justify-content-center flex-column'>
        <div className='d-flex flex-column align-items-center'>
          <ImageComponent
            url={status === 'error' ? errorimg : successfullimg}
            alt='status-img'
            class='justify-content-center w-70p h-70p user-img m-0'
          />
          <span className='font-weight-500 text-32 text-center'>
            {status === 'error'
              ? `Authentication Failed`
              : `You're all set with ${platform} Authentication!`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
